import { useEffect, useRef } from 'react'
import './oficina-world.css'

/** Decorative scroll layers. Only schedule a frame when the viewport changes. */
export default function OficinaWorld() {
  const world = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = world.current
    if (!element) return
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')
    let frame = 0
    function update() {
      frame = 0
      if (!element) return
      const bottom = document.getElementById('porta')?.getBoundingClientRect().bottom ?? innerHeight
      const progress = Math.max(0, Math.min(1, 1 - bottom / innerHeight))
      const moving = !reduced?.matches
      element.style.setProperty('--world-far', `${moving ? progress * -26 : 0}px`)
      element.style.setProperty('--world-desk', `${moving ? progress * -64 : 0}px`)
      element.style.setProperty('--world-edge', `${moving ? progress * 3 : 0}%`)
      element.style.setProperty('--world-cloud', `${moving ? progress * 30 : 0}px`)
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update) }
    update()
    window.addEventListener('scroll', schedule, { passive: true })
    window.addEventListener('resize', schedule)
    reduced?.addEventListener?.('change', schedule)
    return () => {
      cancelAnimationFrame(frame)
      window.removeEventListener('scroll', schedule)
      window.removeEventListener('resize', schedule)
      reduced?.removeEventListener?.('change', schedule)
    }
  }, [])

  const plants = '/assets/illustrations/oficina-folhas.webp'
  return <div className="of-world" ref={world}>
    <div className="of-world__stage" aria-hidden="true">
      <img className="of-world__landscape" src="/assets/illustrations/oficina-paisagem.webp" alt="" fetchPriority="high" width="1536" height="1024" />
      <svg className="of-world__desk" viewBox="0 0 1536 1024" preserveAspectRatio="xMidYMax slice">
        <defs><clipPath id="oficina-desk-contour"><path d="M0 679 L75 666 L207 679 L203 714 L226 727 L222 751 L237 764 L235 784 Q297 782 354 792 Q506 819 688 819 Q836 811 978 801 L1020 796 L1040 740 L1075 737 Q1110 733 1143 747 L1183 768 L1288 742 L1310 743 L1355 746 L1369 692 L1457 700 L1470 671 L1477 671 L1475 700 L1510 701 L1536 702 L1536 1024 L0 1024Z" /></clipPath></defs>
        <image href="/assets/illustrations/oficina-bancada.webp" width="1536" height="1024" clipPath="url(#oficina-desk-contour)" />
      </svg>
    </div>
    <div className="of-world__cloud of-world__cloud--left" aria-hidden="true"><svg viewBox="0 0 480 300"><image href={plants} width="1536" height="1024" /></svg></div>
    <div className="of-world__cloud of-world__cloud--right" aria-hidden="true"><svg viewBox="1120 0 416 300"><image href={plants} width="1536" height="1024" /></svg></div>
    <div className="of-world__edge of-world__edge--left" aria-hidden="true"><svg viewBox="0 320 560 704"><image href={plants} width="1536" height="1024" /></svg></div>
    <div className="of-world__edge of-world__edge--right" aria-hidden="true"><svg viewBox="990 320 546 704"><image href={plants} width="1536" height="1024" /></svg></div>
  </div>
}
